import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";

const Inline = _ref => {
  let {
    className,
    size = 'base',
    wrap = true
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "size", "wrap"]);

  const theme = useTheme();
  return ___EmotionJSX("ul", _extends({
    css: [{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      listStyle: 'none',
      padding: 0,
      margin: "-" + theme.space[size] + "px 0 0 -" + theme.space[size] + "px",
      '> .CK__ListItem': {
        marginLeft: theme.space[size] + "px !important",
        marginTop: theme.space[size] + "px !important"
      }
    }, !wrap && {
      whiteSpace: 'nowrap',
      flexWrap: 'nowrap'
    }, process.env.NODE_ENV === "production" ? "" : ";label:Inline;"],
    className: clsx('CK__Inline', className)
  }, rest));
};

export default Inline;